// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_8g-0";
export var optionCard = "_8g-1";